import React from 'react'
import { Link } from 'react-router-dom'

function Navigation(props) {
  return (
    <div className='shadow-sm bg-gray-50 h-12 items-center  xl:pl-[2.5%]  lg:pl-[3%] md:pl-[4%] xl:pt-[1%]  lg:pt-[1%] md:pt-[1%] hidden sm:block'>
    <div><Link>Home</Link>/ <Link>{props.name}</Link> </div>
  </div>
  )
}

export default Navigation
